import request from "./request";
/**
 * 更新标识id
 * @param id 专页id
 * @param flagGroup 绑定用户名称
 */
export default async function updateFlagGroup(data) {
  return await request.post(
    "/spin/dataAuthorizationPlayer/updateFlagGroup",
    data
  );
}
